import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { MessagesSidebarLayout } from '@/messages/MessagesSidebarLayout';
import { EmptyState } from '@/messages/messagesStyles';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/messages/',
)({
  component: MessagesIndexRoute,
});

function MessagesIndexRoute() {
  const { memberId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <MessagesSidebarLayout
      onThreadClick={(thread) =>
        navigate({
          to: '/members/$memberId/messages/view/$threadId/',
          params: { memberId, threadId: `${thread.id}` },
        })
      }
    >
      <EmptyState>
        {/* Translation Needed */}
        Select a conversation to start messaging.
      </EmptyState>
    </MessagesSidebarLayout>
  );
}
